/// <reference types="vite-plugin-pwa/client" />
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Own the service-worker registration (injectRegister: 'auto' wires this virtual
// module rather than auto-injecting a silent registerSW.js). This surfaces
// registration failures — CSP worker-src, wrong MIME behind a proxy, scope
// mismatch — which would otherwise vanish and leave the PWA silently without
// offline/push support. This is the SINGLE registration path: vite-plugin-pwa
// no longer auto-injects its own registerSW because we call it here.
registerSW({
  immediate: true,
  onRegisterError(error: unknown) {
    console.error('[pwa] service worker registration failed', error);
  },
});

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
